import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';

// import { GlobalModule } from '@fuse/global.module';
import { GlobalModule } from '@fuse/global.module';
import { PlatformIssueReporterComponent } from './platform-issue-reporter.component';

@NgModule({
    imports     : [
       FuseSharedModule,
        GlobalModule,
    ],
    declarations: [
        PlatformIssueReporterComponent
    ],
    providers   : [
    ],
    exports: [
        PlatformIssueReporterComponent
    ],
    entryComponents: [
        PlatformIssueReporterComponent
    ]
})
export class PlatformIssueReporterModule
{
}
